<template>
  <Skeleton v-if="isLoading" class="h-10 mt-1" />
  <p
    v-else
    class="text-xs bg-neutral-600 text-neutral-200 px-2 py-1 rounded mt-1 font-semibold"
  >
    You have canceled your plan. It will be active until
    {{ endDate }} and then converted to Free plan.
  </p>
</template>

<script setup>
import { computed } from 'vue';
import { Skeleton } from '@ui/components/skeleton';
import { useStore } from 'vuex';

const store = useStore();

const endDate = computed(() => {
  if (store.getters['workspace/getCurrentSubscriptionPlan']?.end_date) {
    const date = new Date(
      store.getters['workspace/getCurrentSubscriptionPlan'].end_date
    );
    return date.toLocaleString();
  }
  return null;
});
</script>
